import styled from "styled-components";
import { Resizable } from "react-resizable";

export const TitleBar = styled.div`
  color: ${props => props.theme.modal.headerText};
  background-color: ${props => props.theme.modal.header};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1.5rem;
`;

export const Title = styled.span`
  font-size: 11px;
  padding-left: 0.2rem;
  color: white;
  flex: 1;
`;



// WEBPACK FOOTER //
// ./app/styled-components/Popup.js